import { makeStyles } from '@material-ui/styles';
import CheckIcon from '@material-ui/icons/Check';
import PasswordInput from 'components/PasswordInput/PasswordInput';
import { useTranslation } from 'react-i18next';
import {
  dangerColor,
  successColor,
} from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  validInformationWrapper: { margin: '20px 0' },
  listTitle: { marginBottom: '0' },
  listTitleInvalid: { color: dangerColor[0] },
  listTitleValid: { color: successColor[0] },
  listWrapper: { listStyle: 'none', margin: '8px 0 0', paddingLeft: 0 },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '6px 0',
    color: dangerColor[0],
  },
  listItemValid: { color: successColor[0] },
  icon: { color: successColor[0], fontSize: 18, flex: '0 0 18px' },
  iconPlaceholder: { width: 18, height: 18, flex: '0 0 18px' },
  invalidRepeatPassword: { color: dangerColor[0] },
});

const ChangePasswordForm = ({ state, setState, passwordInputVariant }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    focusedPassword = false,
    focusedPasswordRepeat = false,
    plainPassword = '',
    plainPasswordMatch = '',
  } = state;

  const rules = [
    {
      key: 'length',
      label: t('resetPassword.rules.length'),
      isValid: plainPassword.length >= 8,
    },
    {
      key: 'upper',
      label: t('resetPassword.rules.uppercase'),
      isValid: /[A-Z]/.test(plainPassword),
    },
    {
      key: 'lower',
      label: t('resetPassword.rules.lowercase'),
      isValid: /[a-z]/.test(plainPassword),
    },
    {
      key: 'digit',
      label: t('resetPassword.rules.digit'),
      isValid: /\d/.test(plainPassword),
    },
    {
      key: 'special',
      label: t('resetPassword.rules.special'),
      isValid: /[^A-Za-z0-9\s]/.test(plainPassword),
    },
  ];
  const allRulesValid = rules.every(rule => rule.isValid);

  return (
    <div>
      <PasswordInput
        label={t('employees.newPass')}
        name="plainPassword"
        value={plainPassword}
        state={state}
        setState={setState}
        showPasswordKey="showPassword"
        focusKey="focusedPassword"
        autoComplete="new-password"
        variant={passwordInputVariant}
      />
      {(focusedPassword || plainPassword.length > 0) && !allRulesValid && (
        <div className={classes.validInformationWrapper}>
          <p
            className={`${classes.listTitle} ${
              allRulesValid ? classes.listTitleValid : classes.listTitleInvalid
            }`}
          >
            {t('resetPassword.rules.title')}
          </p>
          <ul className={classes.listWrapper}>
            {rules.map(rule => (
              <li
                key={rule.key}
                className={
                  rule.isValid
                    ? `${classes.listItem} ${classes.listItemValid}`
                    : classes.listItem
                }
              >
                {rule.isValid ? (
                  <CheckIcon className={classes.icon} />
                ) : (
                  <span
                    className={classes.iconPlaceholder}
                    aria-hidden="true"
                  />
                )}
                <span>{rule.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <PasswordInput
        label={t('employees.rNewpass')}
        name="plainPasswordMatch"
        value={plainPasswordMatch}
        state={state}
        setState={setState}
        showPasswordKey="showPasswordRepeat"
        focusKey="focusedPasswordRepeat"
        repeatInput={true}
        autoComplete="off"
        variant={passwordInputVariant}
      />
      {plainPassword !== plainPasswordMatch &&
        !focusedPasswordRepeat &&
        plainPasswordMatch.length > 0 && (
          <p className={classes.invalidRepeatPassword}>
            {t('resetPassword.errors.passwordsMismatch')}
          </p>
        )}
    </div>
  );
};

export default ChangePasswordForm;
